// Function to set a cookie
function setCookie(name, value, hoursToExpire) {
  const now = new Date();
  // const expiration = new Date(now.getTime() + hoursToExpire * 60 * 1000); // Convert minutes to milliseconds
  const expiration = new Date(now.getTime() + hoursToExpire * 60 * 60 * 1000); // Convert hours to milliseconds

  document.cookie = `${name}=${value}; expires=${expiration.toUTCString()}; path=/`;
}

// Function to get a cookie by name
function getCookie(cookieName) {
  const cookies = document.cookie.split(';');
  
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();
    const cookieParts = cookie.split('=');
    
    if (cookieParts[0] === cookieName) {
      return cookieParts[1];
    }
  }
  
  return null; // Return null if the cookie is not found
}

// Function to check if a cookie exists by name
function checkCookie(cookieName) {
  const cookieValue = getCookie(cookieName);
  return cookieValue !== null;
}

